function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import { normalize } from "../common";
import { CONTAINER_NAME } from "../_utils/constant";
var saveImage = normalize.saveImage(function (args) {
  swan.saveImageToPhotosAlbum(_extends({}, args, {
    filePath: args.url
  }));
}, CONTAINER_NAME.BAIDU);
export default saveImage;